import { useContext } from "react";
import { FavoriteGroupsContext } from "../../FavoriteGroupsContext";

export const useFavoriteGroupsContext = () => {
  const context = useContext(FavoriteGroupsContext);
  if (context === undefined) {
    throw new Error(
      "useFavoriteGroups must be used within a FavoriteGroupsProvider"
    );
  }
  return context;
};
